export const icons = [
  'icon-nav-9',
  'icon-xitongpeizhi',
  'icon-jichupeizhi',
  'icon-shebeiguanli',
  'icon-fuwuguanli',
  'icon-shebeijiankong',
  'icon-yuanchengkongzhi1',
  'icon-guzhangguanli',
  'icon-guanggao',
  'icon-baobiao',
  'icon-nav-1',
  'icon-nav-2',
  'icon-nav-3',
  'icon-nav-4',
  'icon-nav-5',
  'icon-nav-6',
  'icon-nav-7',
  'icon-nav-8',
  'icon-nav-10',
  'icon-nav-11',
  'icon-nav-12',
  'icon-nav-13',
  'icon-nav-14',
  'icon-nav-15',
  'icon-nav-16',
  'icon-nav-17',
  'icon-nav-18',
  'icon-nav-19',
  'icon-nav-20',
  'icon-nav-21',
  'icon-nav-22',
  'icon-nav-23',
  'icon-nav-24',
  'icon-nav-25',
  'icon-nav-26',
  'icon-nav-27',
  'icon-nav-28',
  'icon-nav-29',
  'icon-nav-30',
  'icon-nav-31',
  'icon-nav-32',
  'icon-nav-33',
  'icon-nav-34',
  'icon-nav-35',
  'icon-nav-36',
  'icon-nav-37',
  'icon-nav-38',
  'icon-nav-39',
  'icon-nav-40',
  'icon-nav-41',
  'icon-nav-42',
  'icon-nav-43',
  'icon-nav-44',
  'icon-nav-45',
  'icon-nav-46',
  'icon-nav-47',
  'icon-nav-48',
  'icon-nav-49',
  'icon-nav-50'
]


// WEBPACK FOOTER //
// ./src/common/icon.js